export const editCluster = ({
    draftClusters,
    campaign,
    newCluster,
}) => {
    if (clusterDidNotChange(campaign, newCluster)) {
        return draftClusters;
    }

    const clusters = removeCampaignFromCurrentCluster(draftClusters, campaign);
    return insertCampaignOnCluster(clusters, campaign, newCluster);
};

export const createCluster = ({
    draftClusters,
    campaign,
    clusterName,
    clientId,
    organizationId,
}) => {
    const clusters = removeCampaignFromCurrentCluster(draftClusters, campaign);
    const newCluster = createNewClusterWithCampaign(
        campaign, clusterName, clientId, organizationId,
    );

    return [
        ...clusters,
        newCluster,
    ];
};

const removeCampaignFromCurrentCluster = (clusters, campaign) => clusters.map((cluster) => {
    const isCurrentClusterOfCampaign = cluster.name === campaign.cluster;
    if (isCurrentClusterOfCampaign) {
        const remainingObjects = cluster.clusterObjects
            .filter(object => object.objectId !== campaign.campaign_id);

        if (clusterShouldBeDeleted(cluster, remainingObjects)) {
            return null;
        }

        return {
            ...cluster,
            clusterObjects: remainingObjects,
        };
    }

    return cluster;
}).filter(cluster => cluster !== null);

const insertCampaignOnCluster = (clusters, campaign, newCluster) => clusters.map((cluster) => {
    const isNewClusterOfCampaign = cluster.name === newCluster?.value;
    if (isNewClusterOfCampaign) {
        const newObject = {
            objectId: campaign.campaign_id,
            objectType: 'campaign',
            platform: campaign.platform,
            networkId: `${campaign.network_id}`,
        };

        return {
            ...cluster,
            clusterObjects: [
                ...cluster.clusterObjects,
                newObject,
            ],
        };
    }

    return cluster;
});


const createNewClusterWithCampaign = (campaign, clusterName, clientId, organizationId) => {
    const firstClusterObject = {
        objectId: campaign.campaign_id,
        objectType: 'campaign',
        platform: campaign.platform,
        networkId: `${campaign.network_id}`,
    };

    return {
        id: null,
        name: clusterName,
        isBudgetActive: false,
        isTargetActive: false,
        isRecurrent: false,
        clientId,
        organizationId,
        clusterObjects: [firstClusterObject],
        ranges: [{
            budget: 0,
            dateGranularity: 'month',
            dateGranularityAmount: 1,
        }],
    };
};

export const getDistinctClusters = (clusters = []) => clusters
    .filter(cluster => cluster.clusterObjects.length)
    .map(cluster => cluster.name)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

export const getOptions = distinctClusters => distinctClusters
    .map(option => getDefaultValue(option))
    .filter(option => option !== null);

export const getDefaultValue = value => (value ? { value, label: value } : null);

const clusterDidNotChange = (campaign, newCluster) => campaign.cluster === newCluster?.value;

const clusterShouldBeDeleted = (cluster, remainingObjects) => {
    const clusterDoesntExistsOnAPI = !cluster.id;
    const clusterHasNoObjects = remainingObjects.length < 1;

    return clusterDoesntExistsOnAPI && clusterHasNoObjects;
};
